import { Box, Button } from '@mui/material'
import { IconCircleX, IconEdit, IconUpload } from 'assets/images'
import { t } from 'i18n'
import React from 'react'
import { HeatmapDefinition } from 'store/ducks/report/types'

interface HeatmapActionsProps {
  heatmap: HeatmapDefinition
  isReplacing?: boolean
  onSetDefault: (heatmapId: string) => Promise<void>
  onReplace: (heatmap: HeatmapDefinition) => Promise<void>
  onRename: (heatmap: HeatmapDefinition) => void
  onDelete: (heatmap: HeatmapDefinition) => Promise<void>
}

const HeatmapActions: React.FC<HeatmapActionsProps> = ({
  heatmap,
  isReplacing = false,
  onSetDefault,
  onReplace,
  onRename,
  onDelete
}) => {
  return (
    <Box
      display="flex"
      gap={1}
      mt={2}
      flexWrap="wrap"
      justifyContent="flex-end"
    >
      {/* DEFAULT */}
      <Button
        size="small"
        variant={heatmap.isDefault ? 'contained' : 'outlined'}
        onClick={() => onSetDefault(heatmap.id)}
        disabled={heatmap.isDefault}
      >
        {heatmap.isDefault
          ? t('heatmaps.default') || 'Default'
          : t('heatmaps.setDefault') || 'Set Default'}
      </Button>

      {/* REPLACE */}
      <Button
        size="small"
        variant="outlined"
        onClick={() => onReplace(heatmap)}
        disabled={isReplacing}
        startIcon={<IconUpload width="1em" fill="currentColor" />}
      >
        {isReplacing
          ? t('heatmaps.uploading') || 'Uploading...'
          : t('heatmaps.replace') || 'Replace'}
      </Button>

      {/* RENAME */}
      <Button
        size="small"
        variant="outlined"
        onClick={() => onRename(heatmap)}
        startIcon={<IconEdit width="1em" fill="currentColor" />}
      >
        {t('rename') || 'Rename'}
      </Button>

      {/* DELETE */}
      <Button
        size="small"
        variant="outlined"
        color="error"
        onClick={() => onDelete(heatmap)}
        startIcon={<IconCircleX width="1em" fill="currentColor" />}
      >
        {t('delete') || 'Delete'}
      </Button>
    </Box>
  )
}

export default HeatmapActions
